class CommandTriggerForwarder {
    constructor(parentTrigger, childTrigger) {
        if (typeof parentTrigger !== 'object' || parentTrigger === null) {
            throw new Error('parentTrigger is not a CommandTriggerSimple.');
        }

        if (typeof childTrigger !== 'object' || childTrigger === null) {
            throw new Error('childTrigger is not a CommandTriggerSimple.');
        }

        this.parentTrigger = parentTrigger;
        this.childTrigger = childTrigger;
    }

    listen(command) {
        this.childTrigger.listen(command);
    }

    transform(transformer) {
        return this.childTrigger.transformer(transformer);
    }

    trigger(triggerEvent) {
        this.parentTrigger.trigger(triggerEvent);
    }
}

export default CommandTriggerForwarder;
